export const DIMENSIONS = {
    BANNER_IMAGE: {
        WIDTH: "104px",
        HEIGHT: "68px",
    },
    STEPPER_IMAGE: {
        WIDTH: "13px",
        HEIGHT: "125px",
    },
};
